import axios from 'axios';
import {
    BACKEND_URL
} from "../backendURL";


class MemberService {
    
    createRow(url, data) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        return axios.post(url, data, config);
    };
    
    readRows(url) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };
        return axios.get(url, config);
    };

    readRow(url, data) {
    }
    
    updateRow(url, oldData,newData) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        return axios.put(url + oldData.id +'/', newData, config)
    };
    
    deleteRow(url, data) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        return axios.delete(url + data.id + '/', config);
    };

    getCurrentUserData(token) {

        const config = {
            headers: {
                'Authorization': "Token " + token
            },

        };

        let request_url = BACKEND_URL + "/api/hr/currentuser/";

        return axios.get(request_url, config);
    };

    geMyProfileAccesses(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },

        };

        let request_url = BACKEND_URL + "/api/hr/profile/my-accesses/";

        return axios.get(request_url, config);
    };

    getCurrentMemberData(token) {

        const config = {
            headers: {
                'Authorization': "Token " + token
            },

        };

        let request_url = BACKEND_URL + "/api/hr/current-member-data/";

        return axios.get(request_url, config);
    };


    getCurrentAnetarData(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const apiUrl = BACKEND_URL + "/api/hr/current-anetar-data/";
        return axios.get(apiUrl, config);
    };
}

export default new MemberService();